import { Fragment, useContext, useEffect } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import MenuDrower from "../menuDrower/MenuDrower";
import { useLocation } from "react-router-dom";
import PaymentModel from "../paymentModel/PaymentModel";
import { MainContext } from "../WebContext";

const PageLayout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/about_navakodi") {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);

  const { paymentModal, setPaymentModal } = useContext(MainContext);
  return (
    <Fragment>
      <Header />
      <MenuDrower />
      {children}
      <PaymentModel show={paymentModal} onHide={() => setPaymentModal(false)} />
      <Footer />
    </Fragment>
  );
};

export default PageLayout;
